import React, {useContext} from 'react';
import {fetchDatasetPage} from '../../../state/api/datasetSliceApi';
import {useTranslation} from "react-i18next";
import PageableDataCards from "./PageableDataCards";
import {UserContext} from "../../../context/UserContext";

const DataSets = () => {
    const {t} = useTranslation();
    const {user, _} = useContext(UserContext);
    // we could separate  state of data for when data is public only when user is not authenticated and either public or private when user is authenticated
    return <PageableDataCards
        selector={(state) => state.datasetSliceApi.list}
        loadingSelector={(state) => state.datasetSliceApi.loading}
        fetchAction={fetchDatasetPage}
        refreshState={user?.hasLoaded}
        defaultSort={"sort=name,asc"}
        filterColumns={[
            {id: "name", type: "string", name: t('dataset.name')},
            {id: "lastModifiedAt", type: "date", name: t('dataset.last_modified_at')},
            {id: "description", type: "string", name: t('dataset.description')},
            {id: "isPublic", type: "boolean", name: t('dataset.isPublic')},
        ]}
    />
};

export default DataSets;
